import PropTypes from 'prop-types'
/* eslint no-unused-vars: 0 */
/* eslint react/prefer-stateless-function: 0 */

import React, { Component } from 'react'
import HomeHeader from './HomeHeader'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import HomeSidebar from './HomeSidebar'
import RecentRoutes from './routes/RecentRoutes'
import RecentWorkouts from './workouts/RecentWorkouts'
import RecentCourses from './courses/RecentCourses'

const mapStateToProps = (state) => ({
})

const mapDispatchToActions = {
}

export class Dashboard extends Component {
  static propTypes = {
  }

  render () {
    return (
      <div>
        <HomeHeader />
        <Row>
          <Col xs={12} sm={8}>
            <RecentWorkouts />
            <RecentRoutes />
            <RecentCourses />
          </Col>
          <Col xs={12} sm={4}>
            <HomeSidebar />
          </Col>
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(Dashboard)
